// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Container } from '../../components/Elemental'
// import { hotjar } from 'react-hotjar'

// Components/Containers
import Alert from '../Alert'
import Header from '../Header'
import Onboarding from '../Onboarding'

// CSS
import './styles.scss'

class Auth extends Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    const { err, success } = nextProps

    if (err || success) {
      try {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        });
      }
      catch (err) {
        console.log(err)
      }
    }
  }

  render() {
    const { alert, children } = this.props

    return (
      <div className={alert.visible ? "auth auth--with-alert" : "auth"}>
        <div className="auth__header">
          <Alert />
          <Header />
        </div>
        <Onboarding />
        <Container>
          {children}
        </Container>
      </div>
    )
  }
}

Auth = connect(state => {
  return {
    alert: state.alert,
    err: state.app.err,
    success: state.app.success,
    invited: state.auth.invited,
    user: state.auth.user,
  }
}, {})(Auth)

export default Auth
